import React from 'react'

const SettingsAccount = () => {
  return <h1 className='title'>My Account</h1>
}

export default SettingsAccount
